export const Icon1 = require('./icon-1.png');
export const Icon2 = require('./icon-2.png');
export const Icon3 = require('./icon-3.png');